@if (user?.roleLevel === 95) {
  <div class="custom" id="tab-group">
    <h3 class="mt-3 mb-3">{{ "RESIDENTS" | translate }}</h3>

    <!-- Residents view selector -->
    <div class="view-toggle mb-3" role="group" [attr.aria-label]="'RESIDENTS' | translate">
      @for (view of views; track view.key) {
        <button
          type="button"
          class="view-toggle-option"
          [class.selected]="selectedView === view.key"
          [attr.aria-pressed]="selectedView === view.key"
          (click)="selectedView = view.key">
          {{ view.label | translate }}
        </button>
      }
    </div>

    <!-- All lists stay mounted and inactive ones are only hidden, so switching views
         keeps unsaved edits and selections (e.g. display names in the NEW list) -->
    <div [hidden]="selectedView !== 'new'"><new-residents></new-residents></div>
    <div [hidden]="selectedView !== 'changes'"><flagged-residents></flagged-residents></div>
    <div [hidden]="selectedView !== 'all'"><all-residents></all-residents></div>
  </div>
}
